import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/contact.css";

const Contact = () => {

    const navigate = useNavigate();

    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        message: ""
    });

    const [status, setStatus] = useState("idle");
    const [countdown, setCountdown] = useState(3);

    const SCRIPT_URL =
        "https://script.google.com/macros/s/AKfycbzPAaf0yhN6tHLaEbYCGjtA0Qp2HYnJfCOLfWpMVKnuStO35DFVYPP1SvwVrDJaQfMzPw/exec";

    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm({
            ...form,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {

        e.preventDefault();
        setStatus("loading");

        try {

            await fetch(SCRIPT_URL, {
                method: "POST",
                mode: "no-cors",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(form)
            });

            setStatus("success");

            setForm({
                name: "",
                email: "",
                phone: "",
                message: ""
            });

            let timer = 3;

            const interval = setInterval(() => {

                timer--;
                setCountdown(timer);

                if (timer === 0) {
                    clearInterval(interval);
                    navigate("/");
                }

            }, 1000);

        } catch (error) {

            console.error(error);
            setStatus("error");

        }
    };

    return (
        <div className="contact-page">

            {/* HERO SECTION */}

            <section className="contact-hero">
                <div className="container">
                    <h1>Contact Us</h1>
                    <p>
                        Connect with our experts to discuss taxation, bookkeeping,
                        e-commerce management, or technology services for your business.
                    </p>
                </div>
            </section>


            <section className="contact-container container">

                {/* LEFT SIDE */}

                <div className="contact-left">

                    <div className="map-box">

                        <iframe
                            title="Sibora Global Location"
                            src="https://www.google.com/maps?q=Ujjain&output=embed"
                            width="100%"
                            height="260"
                            style={{ border: 0 }}
                            loading="lazy"
                        ></iframe>

                    </div>

                    <div className="contact-info-card">

                        <h3>Office Address</h3>

                        <p>Sibora Global</p>

                        <p>Email: info@siboraglobal.com</p>

                    </div>

                </div>


                {/* RIGHT SIDE FORM */}

                <form className="contact-form" onSubmit={handleSubmit} noValidate>

                    <input
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        placeholder="Full Name"
                        required
                    />

                    <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="Business Email"
                        required
                    />

                    <input
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        placeholder="Phone Number"
                        required
                    />

                    <textarea
                        name="message"
                        value={form.message}
                        onChange={handleChange}
                        placeholder="How can we help your business?"
                        rows="5"
                    ></textarea>

                    <button type="submit" disabled={status === "loading"}>
                        {status === "loading" ? "Submitting..." : "Submit Enquiry"}
                    </button>


                    {status === "success" && (
                        <div className="form-success">
                            Your enquiry has been submitted successfully. Redirecting in {countdown} seconds.
                        </div>
                    )}


                    {status === "error" && (
                        <div className="form-error">
                            Unable to submit your enquiry. Please try again later.
                        </div>
                    )}

                </form>
                <br></br>
            </section>

        </div>
    );
};

export default Contact;